/**
 * Component: Logos Gallery
 * 
 */
'use strict';

export class LogosGallery
{
  constructor() {
    this.selectors = document.querySelectorAll('.c-logos-gallery');
  }

  init() {

    let _self = this;

    _self.selectors.forEach( gallery => {
      const galleryId = gallery.dataset.galleryId;
      const galleryVisibleItems = gallery.dataset.galleryVisible ? parseInt(gallery.dataset.galleryVisible) : 12;
      const logos = ( typeof galleryId !== 'undefined' ) ? JSON.parse(window[galleryId].logos) : [];

      // array of unique numbers
      let visibleLogos = [];

      if ( logos && logos.length ) {
        // push randomly sorted indexes to `visibleLogos`
        visibleLogos = logos.map((element, index, array) => ( index )).sort(() => Math.random() - 0.5).filter((element, index, array) => index < galleryVisibleItems);

        // console.log('visibleLogos', visibleLogos);

        // set initial logo set (random logo set each time page load)
        let imgCount = 0;
        for (const [i, imgElm] of logos.entries()) {
          // bail if gallery max items count reached 
          if ( imgCount == galleryVisibleItems ) { break; }

          let logoImg = document.createElement('img');
          logoImg.src = logos[visibleLogos[i]]['src'];
          logoImg.alt = logos[visibleLogos[i]]['alt'];
          logoImg.width = logos[visibleLogos[i]]['width'];
          logoImg.height = logos[visibleLogos[i]]['height'];
          logoImg.classList.add('w-full');
          logoImg.loading = 'lazy';
          logoImg.setAttribute('decoding', 'async');

          gallery.appendChild(logoImg);

          imgCount++;
        }

        // Get all of our newly created image elements 
        const imgElements = [...gallery.querySelectorAll('img')];

        // change url on random image every 2s
        if ( logos.length > galleryVisibleItems ) {
          setInterval(() => {
            changeRandomLogo(imgElements)
          }, 2000);
        }
      }

      // function for changing random image source URL
      function changeRandomLogo(imgElements) {
        //  generate random number with limit of `logos.length`
        const randomLogoNr = Math.floor(Math.random() * logos.length);

        //  get always UNIQUE random number from `imgElements` array
        const randomImgNr = Math.floor(Math.random() * visibleLogos.length);
        const randomImgElm = imgElements[randomImgNr];

        //  if `visibleLogos` array contain `randomLogoNr`
        if (visibleLogos.includes(randomLogoNr)) {
          // run function again
          changeRandomLogo(imgElements);
        } else {
          visibleLogos[randomImgNr] = randomLogoNr;
          // change image `scr` URL
          randomImgElm.classList.add('changing-src');
          setTimeout(() => {
            randomImgElm.src = logos[randomLogoNr]['src'];
            randomImgElm.alt = logos[randomLogoNr]['alt'];
            randomImgElm.width = logos[randomLogoNr]['width'];
            randomImgElm.height = logos[randomLogoNr]['height'];
            randomImgElm.classList.remove('changing-src');
          }, 800);
        }
      }

    });

  }
}